import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Πολιτική Επιστροφών Nalumer | Ακυρώσεις Catering</title>
        <meta name="description" content="Η πολιτική επιστροφών του Nalumer εξηγεί ακυρώσεις, επιστροφή χρημάτων και χρονοδιαγράμματα για παραγγελίες catering, ανάλογα με την ημερομηνία της εκδήλωσης." />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Πολιτική Επιστροφών και Επιστροφής Χρημάτων</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Γενικές Αρχές</h2>
          <p>
            Στο Nalumer, στοχεύουμε στην απόλυτη ικανοποίηση των πελατών μας. Κατανοούμε ότι 
            μπορεί να προκύψουν περιστάσεις που απαιτούν ακύρωση ή επιστροφή χρημάτων. Αυτή η 
            πολιτική περιγράφει τους όρους και τις προϋποθέσεις για ακυρώσεις, επιστροφές και 
            επιστροφή χρημάτων για τις υπηρεσίες catering μας.
          </p>
        </section>

        <section>
          <h2>2. Χρονοδιάγραμμα Ακύρωσης</h2>
          <p>
            Η πολιτική επιστροφής χρημάτων εξαρτάται από το πότε ακυρώνετε την παραγγελία σας 
            σε σχέση με την προγραμματισμένη ημερομηνία εκδήλωσης:
          </p>

          <h3>2.1 Ακύρωση πάνω από 7 ημέρες πριν</h3>
          <ul>
            <li><strong>Ποσοστό επιστροφής:</strong> 100%</li>
            <li><strong>Χρόνος επεξεργασίας:</strong> 5-7 εργάσιμες ημέρες</li>
            <li><strong>Όροι:</strong> Πλήρης επιστροφή χωρίς χρέωση ακύρωσης</li>
          </ul>

          <h3>2.2 Ακύρωση 4-7 ημέρες πριν</h3>
          <ul>
            <li><strong>Ποσοστό επιστροφής:</strong> 75%</li>
            <li><strong>Χρέωση ακύρωσης:</strong> 25% της συνολικής αξίας</li>
            <li><strong>Αιτιολογία:</strong> Κάλυψη κόστους προετοιμασίας και κράτησης</li>
          </ul>

          <h3>2.3 Ακύρωση 48-72 ώρες πριν</h3>
          <ul>
            <li><strong>Ποσοστό επιστροφής:</strong> 50%</li>
            <li><strong>Χρέωση ακύρωσης:</strong> 50% της συνολικής αξίας</li>
            <li><strong>Αιτιολογία:</strong> Υλικά ήδη αγορασμένα και προετοιμασία σε εξέλιξη</li>
          </ul>

          <h3>2.4 Ακύρωση λιγότερο από 48 ώρες πριν</h3>
          <ul>
            <li><strong>Ποσοστό επιστροφής:</strong> 0%</li>
            <li><strong>Χρέωση ακύρωσης:</strong> 100% της συνολικής αξίας</li>
            <li><strong>Αιτιολογία:</strong> Πλήρης προετοιμασία ολοκληρωμένη, αδυναμία επαναπώλησης</li>
          </ul>
        </section>

        <section>
          <h2>3. Διαδικασία Ακύρωσης</h2>
          <p>Για να ακυρώσετε την παραγγελία σας, παρακαλούμε ακολουθήστε αυτά τα βήματα:</p>
          <ol>
            <li>Επικοινωνήστε μαζί μας το συντομότερο δυνατό μέσω:
              <ul>
                <li>Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
                <li>Τηλέφωνο: +30 210 1234567</li>
                <li>Φόρμα επικοινωνίας στον ιστότοπο</li>
              </ul>
            </li>
            <li>Παρέχετε τον αριθμό παραγγελίας σας και τα στοιχεία επικοινωνίας</li>
            <li>Αναφέρετε το λόγο ακύρωσης (προαιρετικό αλλά εκτιμάται)</li>
            <li>Λάβετε γραπτή επιβεβαίωση ακύρωσης από την ομάδα μας</li>
            <li>Η επιστροφή χρημάτων θα επεξεργαστεί σύμφωνα με το χρονοδιάγραμμα</li>
          </ol>
          <p>
            <strong>Σημαντικό:</strong> Η ακύρωση θεωρείται ολοκληρωμένη μόνο αφού λάβετε 
            γραπτή επιβεβαίωση από την Nalumer.
          </p>
        </section>

        <section>
          <h2>4. Τροποποιήσεις Παραγγελίας</h2>
          <h3>4.1 Αλλαγές στον Αριθμό Ατόμων</h3>
          <p>Μπορείτε να τροποποιήσετε τον αριθμό των ατόμων μέχρι 48 ώρες πριν την εκδήλωση:</p>
          <ul>
            <li><strong>Αύξηση:</strong> Δεκτή με βάση τη διαθεσιμότητα</li>
            <li><strong>Μείωση έως 10%:</strong> Χωρίς χρέωση</li>
            <li><strong>Μείωση 10-25%:</strong> Χρέωση 15% επί της διαφοράς</li>
            <li><strong>Μείωση πάνω από 25%:</strong> Χρέωση 25% επί της διαφοράς</li>
          </ul>

          <h3>4.2 Αλλαγές στο Μενού</h3>
          <p>
            Αλλαγές στο μενού είναι δυνατές μέχρι 5 ημέρες πριν την εκδήλωση, υπό την 
            προϋπόθεση διαθεσιμότητας των υλικών. Ενδέχεται να ισχύουν πρόσθετες χρεώσεις 
            ανάλογα με τις αλλαγές.
          </p>

          <h3>4.3 Αλλαγή Ημερομηνίας</h3>
          <p>
            Η αλλαγή της ημερομηνίας εκδήλωσης είναι δυνατή μία φορά χωρίς χρέωση, εφόσον:
          </p>
          <ul>
            <li>Γίνει τουλάχιστον 7 ημέρες πριν την αρχική ημερομηνία</li>
            <li>Η νέα ημερομηνία είναι εντός 3 μηνών</li>
            <li>Υπάρχει διαθεσιμότητα για τη νέα ημερομηνία</li>
          </ul>
        </section>

        <section>
          <h2>5. Μέθοδοι Επιστροφής Χρημάτων</h2>
          <h3>5.1 Τρόπος Επιστροφής</h3>
          <p>Η επιστροφή χρημάτων θα γίνει με τον ίδιο τρόπο που πραγματοποιήθηκε η πληρωμή:</p>
          <ul>
            <li><strong>Πιστωτική/Χρεωστική κάρτα:</strong> 5-10 εργάσιμες ημέρες</li>
            <li><strong>PayPal:</strong> 3-5 εργάσιμες ημέρες</li>
            <li><strong>Τραπεζική μεταφορά:</strong> 7-14 εργάσιμες ημέρες</li>
            <li><strong>Αντικαταβολή:</strong> Τραπεζική μεταφορά 7-14 εργάσιμες ημέρες</li>
          </ul>

          <h3>5.2 Καθυστερήσεις Επιστροφής</h3>
          <p>
            Εάν δεν έχετε λάβει την επιστροφή χρημάτων εντός του αναμενόμενου χρονικού 
            πλαισίου, παρακαλούμε:
          </p>
          <ol>
            <li>Ελέγξτε ξανά τον τραπεζικό σας λογαριασμό</li>
            <li>Επικοινωνήστε με την τράπεζα/πάροχο πληρωμών σας</li>
            <li>Επικοινωνήστε μαζί μας στο <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
          </ol>
        </section>

        <section>
          <h2>6. Ειδικές Περιπτώσεις</h2>
          <h3>6.1 Ανωτέρα Βία</h3>
          <p>
            Σε περιπτώσεις ανωτέρας βίας (ακραίες καιρικές συνθήκες, φυσικές καταστροφές, 
            πανδημίες κ.λπ.):
          </p>
          <ul>
            <li>Πλήρης επιστροφή χρημάτων ή</li>
            <li>Αναβολή χωρίς χρέωση σε μελλοντική ημερομηνία</li>
            <li>Πίστωση για μελλοντική χρήση εντός 12 μηνών</li>
          </ul>

          <h3>6.2 Προβλήματα Ποιότητας</h3>
          <p>
            Εάν δεν είστε ικανοποιημένοι με την ποιότητα των τροφίμων ή των υπηρεσιών:
          </p>
          <ul>
            <li>Ειδοποιήστε μας αμέσως κατά τη διάρκεια της εκδήλωσης ή εντός 24 ωρών</li>
            <li>Παρέχετε φωτογραφίες και λεπτομερή περιγραφή του προβλήματος</li>
            <li>Θα αξιολογήσουμε το παράπονο και θα προσφέρουμε:
              <ul>
                <li>Μερική ή πλήρη επιστροφή χρημάτων</li>
                <li>Πίστωση για μελλοντική παραγγελία</li>
                <li>Αντικατάσταση προϊόντων χωρίς χρέωση</li>
              </ul>
            </li>
          </ul>

          <h3>6.3 Μη Παράδοση</h3>
          <p>
            Σε περίπτωση που δεν μπορέσουμε να εκτελέσουμε την παραγγελία σας:
          </p>
          <ul>
            <li>Θα σας ειδοποιήσουμε το συντομότερο δυνατό</li>
            <li>Πλήρης επιστροφή χρημάτων εντός 5 εργάσιμων ημερών</li>
            <li>Αποζημίωση για τυχόν άμεσες ζημίες (έως 25% της αξίας παραγγελίας)</li>
          </ul>
        </section>

        <section>
          <h2>7. Μη Επιστρέψιμα Στοιχεία</h2>
          <p>Τα ακόλουθα δεν είναι επιλέξιμα για επιστροφή χρημάτων:</p>
          <ul>
            <li>Προσαρμοσμένα/εξατομικευμένα στοιχεία που παρασκευάστηκαν ειδικά για εσάς</li>
            <li>Ευπαθή τρόφιμα που παραδόθηκαν και αποδέχθηκαν</li>
            <li>Υπηρεσίες που έχουν ήδη παρασχεθεί</li>
            <li>Τελευταίας στιγμής παραγγελίες (λιγότερο από 24 ώρες)</li>
            <li>Προσφορές και εκπτωτικά πακέτα (μπορεί να ισχύουν διαφορετικοί όροι)</li>
          </ul>
        </section>

        <section>
          <h2>8. Πιστώσεις και Δωροεπιταγές</h2>
          <h3>8.1 Πιστώσεις Καταστήματος</h3>
          <p>
            Σε ορισμένες περιπτώσεις, μπορούμε να προσφέρουμε πίστωση καταστήματος αντί για 
            επιστροφή χρημάτων:
          </p>
          <ul>
            <li>Η πίστωση ισχύει για 12 μήνες από την ημερομηνία έκδοσης</li>
            <li>Μπορεί να χρησιμοποιηθεί για οποιαδήποτε υπηρεσία catering</li>
            <li>Δεν μπορεί να μετατραπεί σε μετρητά</li>
            <li>Μεταβιβάσιμη σε άλλο άτομο</li>
          </ul>

          <h3>8.2 Δωροεπιταγές</h3>
          <p>
            Οι δωροεπιταγές δεν μπορούν να επιστραφούν για επιστροφή χρημάτων, αλλά:
          </p>
          <ul>
            <li>Ισχύουν για 24 μήνες από την ημερομηνία αγοράς</li>
            <li>Μπορούν να μεταφερθούν σε άλλο άτομο</li>
            <li>Μπορούν να επεκταθούν με αίτηση πριν τη λήξη</li>
          </ul>
        </section>

        <section>
          <h2>9. Διαφωνίες και Παράπονα</h2>
          <h3>9.1 Διαδικασία Επίλυσης</h3>
          <p>Εάν διαφωνείτε με μια απόφαση επιστροφής χρημάτων:</p>
          <ol>
            <li>Υποβάλετε γραπτό παράπονο με όλα τα σχετικά έγγραφα</li>
            <li>Θα αναθεωρήσουμε την περίπτωσή σας εντός 5 εργάσιμων ημερών</li>
            <li>Μπορεί να ζητηθεί πρόσθετη τεκμηρίωση</li>
            <li>Θα λάβετε γραπτή απόφαση με αιτιολόγηση</li>
            <li>Εάν παραμένετε δυσαρεστημένοι, μπορείτε να προσφύγετε σε διαμεσολάβηση</li>
          </ol>

          <h3>9.2 Κλιμάκωση</h3>
          <p>Επίπεδα κλιμάκωσης για ανεπίλυτα ζητήματα:</p>
          <ul>
            <li><strong>Επίπεδο 1:</strong> Εξυπηρέτηση πελατών</li>
            <li><strong>Επίπεδο 2:</strong> Διευθυντής λειτουργιών</li>
            <li><strong>Επίπεδο 3:</strong> Γενικός διευθυντής</li>
            <li><strong>Επίπεδο 4:</strong> Διαμεσολάβηση τρίτου μέρους</li>
          </ul>
        </section>

        <section>
          <h2>10. Καταχρηστικές Επιστροφές</h2>
          <p>
            Διατηρούμε το δικαίωμα να αρνηθούμε επιστροφές ή να ακυρώσουμε λογαριασμούς σε 
            περιπτώσεις:
          </p>
          <ul>
            <li>Επαναλαμβανόμενων αδικαιολόγητων ακυρώσεων</li>
            <li>Ύποπτης ή δόλιας δραστηριότητας</li>
            <li>Παραβίασης των όρων χρήσης</li>
            <li>Καταχρηστικής συμπεριφοράς προς το προσωπικό</li>
            <li>Παροχής ψευδών πληροφοριών</li>
          </ul>
        </section>

        <section>
          <h2>11. Εξαιρέσεις για Εταιρικά Πακέτα</h2>
          <p>
            Για εταιρικές εκδηλώσεις και μεγάλα πακέτα (πάνω από 100 άτομα), ισχύουν διαφορετικοί 
            όροι:
          </p>
          <ul>
            <li>Προκαταβολή 30-50% απαιτείται κατά την κράτηση</li>
            <li>Η προκαταβολή είναι μη επιστρέψιμη λιγότερο από 14 ημέρες πριν</li>
            <li>Ειδικοί όροι ακύρωσης συμφωνούνται εγγράφως</li>
            <li>Μπορεί να εφαρμοστούν πρόσθετες χρεώσεις για εξοπλισμό και προσωπικό</li>
          </ul>
        </section>

        <section>
          <h2>12. Επιστροφές για Τεχνικά Προβλήματα</h2>
          <p>
            Εάν αντιμετωπίσατε τεχνικά προβλήματα κατά την παραγγελία που οδήγησαν σε λανθασμένη 
            χρέωση:
          </p>
          <ul>
            <li>Επικοινωνήστε μαζί μας εντός 48 ωρών</li>
            <li>Παρέχετε στιγμιότυπα οθόνης ή απόδειξη του προβλήματος</li>
            <li>Πλήρης επιστροφή χρημάτων ή διόρθωση της παραγγελίας</li>
            <li>Πρόσθετη πίστωση 10% για την αναστάτωση</li>
          </ul>
        </section>

        <section>
          <h2>13. Επικοινωνία για Επιστροφές</h2>
          <p>
            Για οποιαδήποτε ερώτηση ή αίτημα σχετικά με επιστροφές και επιστροφή χρημάτων:
          </p>
          <ul>
            <li><strong>Email:</strong> <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
            <li><strong>Τηλέφωνο:</strong> +30 210 1234567 (Δευτέρα-Παρασκευή, 9:00-18:00)</li>
            <li><strong>Φόρμα επικοινωνίας:</strong> Μέσω του ιστότοπου</li>
            <li><strong>Ταχυδρομική διεύθυνση:</strong> Τμήμα Επιστροφών, Nalumer, Αθήνα, Ελλάδα</li>
          </ul>
          <p>
            <strong>Χρόνος απόκρισης:</strong> Απαντάμε σε όλα τα αιτήματα επιστροφής εντός 
            24-48 ωρών κατά τις εργάσιμες ημέρες.
          </p>
        </section>

        <section>
          <h2>14. Τροποποιήσεις Πολιτικής</h2>
          <p>
            Διατηρούμε το δικαίωμα να τροποποιούμε αυτήν την πολιτική επιστροφών ανά πάσα στιγμή. 
            Οι αλλαγές θα δημοσιεύονται σε αυτήν τη σελίδα με ενημερωμένη ημερομηνία. Οι 
            παραγγελίες που πραγματοποιήθηκαν πριν από τις αλλαγές υπόκεινται στους όρους που 
            ίσχυαν κατά την ημερομηνία παραγγελίας.
          </p>
        </section>

        <section className="policy-footer">
          <p>
            <strong>Ημερομηνία έναρξης ισχύος:</strong> 01/01/2024
          </p>
          <p>
            Ευχαριστούμε που επιλέξατε το Nalumer. Δεσμευόμαστε να παρέχουμε εξαιρετική 
            υπηρεσία και δίκαιη μεταχείριση σε όλες τις συναλλαγές.
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default RefundPolicy;